import { Component, Inject } from "@angular/core";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { LicenseService } from "../../../../services/LicenseService";
import { AdalService } from "../../../../shared/adal.service";
import { AppLoaderService } from "../../../../../services/app-loader/app-loader.service";

@Component({
  selector: "view-gis360-activation-details",
  template: require('./view-gis360-activation-details.component.html'),
})
export class ViewGIS360ActivationDetailsComponent {
  dialogTitle = "";
  errorMessage = "";
  isLoading = false;
  // License Key row of the expanded panel [LicenseKeyId for the API, LicenseKey for the title]
  selectedSubRow;
  activationDetails = [];
  // Delete permission of the portal user: shows Deactivate
  IsDelete = false;
  // Grid list returned by the last Deactivate; given back to the grid when the popup closes
  licenseList = null;

  constructor(
    private dialogRef: MdDialogRef<ViewGIS360ActivationDetailsComponent>,
    private licenseService: LicenseService,
    private appLoader: AppLoaderService,
    private snackBar: MdSnackBar,
    private adalService: AdalService,
    private router: Router,
    @Inject(MD_DIALOG_DATA) public dialogData: any,
  ) {
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close(null);
      this.router.navigate(["login"]);
    }
    this.dialogTitle = this.dialogData.dialogTitle;
    this.selectedSubRow = this.dialogData.SelectedSubRow;
    this.IsDelete = this.dialogData.IsDelete;
    this.getActivationDetails();
  }

  getActivationDetails() {
    this.isLoading = true;
    this.licenseService.getGIS360ActivationDetails(this.selectedSubRow.LicenseKeyId).subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
          this.activationDetails = data.DataObject;
          this.errorMessage = this.activationDetails.length == 0 ? "No activation details found." : "";
        } else {
          this.errorMessage = data.Error;
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.errorMessage = "Something went wrong.";
      },
    );
  }

  // Copies the activation key (signed license document) so it can be given to the customer
  copyActivationKey(row) {
    const textArea = document.createElement("textarea");
    textArea.value = row.ActivationKey;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    this.snackBar.open("Activation key copied", "", { duration: 3000 });
  }

  // Deactivates the activation from the portal: the License Key is free at once, the device's next refresh is refused
  deactivate(row) {
    Swal.fire({
      title: "Deactivate License Key",
      text:
        "Are you sure you want to deactivate license key " +
        this.selectedSubRow.LicenseKey +
        " on " +
        row.DeviceName +
        "? The device will lose its license at its next refresh.",
      showCancelButton: true,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonColor: "#FFCA28",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        const model = {
          ActivationId: row.ActivationId,
          UpdatedBy: Number(localStorage.getItem("userid")),
        };
        this.appLoader.open();
        this.licenseService.DeactivateGIS360Activation(model).subscribe(
          (data) => {
            this.appLoader.close();
            if (!data.IsError && data.DataObject != null) {
              this.snackBar.open("License key deactivated successfully", "", { duration: 3000 });
              this.licenseList = data.DataObject.LicenseList;
              this.getActivationDetails();
            } else {
              this.snackBar.open(data.Error, "", { duration: 3000 });
            }
          },
          (err) => {
            this.appLoader.close();
            this.snackBar.open("Something went wrong.", "", { duration: 3000 });
          },
        );
      }
    });
  }

  onCancel() {
    // After a Deactivate the grid gets the updated list [activation counts, Edit / Delete buttons]
    this.dialogRef.close(this.licenseList ? { LicenseList: this.licenseList } : false);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/gis360/popup/view-gis360-activation-details/view-gis360-activation-details.component.ts